import React, {useState} from "react";
import './ResponsiveSignup.scss'
import {signUpUser} from "../../store/actions/usersActions";
import logo from "../../assets/logo/logo_agronet.png";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import ErrorModal from "../_common/ErrorModal";
import {toggleModal} from "../../store/actions/toggleModalActions";

const selector = state => {
    return {
        disableButtons: state.disableButtons,
        modalState: state.modalState,
        authError: state.authError,
        t: state.language.translator
    };
};

const ResponsiveSignup = () => {

    const { t, disableButtons, modalState, authError } = useSelector(selector);
    const dispatch = useDispatch();
    const history = useHistory();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [signUpName, setSignUpName] = useState('');
    const [signUpEmail, setSignUpEmail] = useState('');
    const [signUpPhone, setSignUpPhone] = useState('');
    const [signUpPassword, setSignUpPassword] = useState('');
    const [signupLastName, setSignupLastName] = useState('');
    const [distributor, setDistributor] = useState('mobile');

    const location = useLocation();

    return (
        <>
            <div className="responsiveContainer">
                <div
                    className={'loginWindow signUp'}
                    // onKeyDown={loginOnEnter}
                >
                    <img className={'loginLogo loginLogo--signUp'} src={logo} alt='App logo'/>

                    <div className="loginFormTitle">
                        {t.gettext('Sign up')}
                    </div>
                    <form className='loginForm'>
                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                className='loginFormSignupInput'
                                value={signUpName}
                                onInput={e => {
                                    setSignUpName(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Last Name')}
                            </label>
                            <input
                                className='loginFormSignupInput'
                                value={signupLastName}
                                onInput={e => {
                                    setSignupLastName(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Email')}
                            </label>
                            <input
                                className='loginFormSignupInput'
                                value={signUpEmail}
                                onInput={e => {
                                    setSignUpEmail(e.target.value);
                                }}
                                type='email'
                            />
                        </div>
                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Password')}
                            </label>
                            <input
                                className='loginFormSignupInput'
                                value={signUpPassword}
                                onInput={e => {
                                    setSignUpPassword(e.target.value);
                                }}
                                type='password'
                            />
                        </div>
                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Phone number')}
                            </label>
                            <input
                                className='loginFormSignupInput'
                                value={signUpPhone}
                                onInput={e => {
                                    setSignUpPhone(e.target.value);
                                }}
                                type='number'
                            />
                        </div>
                        <div className='loginButtonHolder'>
                            <button
                                className={!signUpName || !signUpEmail || !signUpPassword ? 'loginButton loginButton--disabled' : 'loginButton'}
                                onClick={e => {
                                    e.preventDefault();
                                    dispatch(signUpUser(signUpName, signUpEmail, signUpPhone, signUpPassword, distributor, signupLastName))
                                }}
                                disabled={!signUpName || !signUpEmail || !signUpPassword}
                            >
                                {t.gettext('Sign up').toUpperCase()}
                            </button>
                        </div>
                    </form>
                    {modalState.flag && modalState.modal === 'signUpComplete' &&
                        <ErrorModal
                            error={t.gettext('Sign up request has been sent')}
                            closeMethod={() => dispatch(toggleModal(false, ''))}
                        />
                    }
                    {modalState.flag && modalState.modal === 'signUpFailed' &&
                        <ErrorModal
                            error={t.gettext('Sign up failed')}
                            requestFailed
                            closeMethod={() => dispatch(toggleModal(false, ''))}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default ResponsiveSignup;
